// Placeholder API calls — all will be replaced with real n8n endpoints later.
// Each function returns mock data for UI development purposes.

export async function fetchDashboardSummary() {
  const res = await fetch(
    'https://n8nbotibonga.botibonga.com/webhook/27ad14eb-8f60-46e5-b827-f99265904455/api/dashboard/summary'
  );
  if (!res.ok) throw new Error('Failed to fetch dashboard summary');
  const data = await res.json();
  return Array.isArray(data) ? data[0] : data;
}

export async function fetchConversations() {
  const res = await fetch(
    'https://n8nbotibonga.botibonga.com/webhook/27ad14eb-8f60-46e5-b827-f99265904455/api/conversations'
  );
  if (!res.ok) throw new Error('Failed to fetch conversations');
  return res.json();
}

export async function fetchConversation(sessionId) {
  const res = await fetch(
    `https://n8nbotibonga.botibonga.com/webhook/27ad14eb-8f60-46e5-b827-f99265904455/api/conversations/${sessionId}`
  );
  if (!res.ok) throw new Error('Failed to fetch conversation');
  return res.json();
}

export async function fetchLeads() {
  const res = await fetch(
    'https://n8nbotibonga.botibonga.com/webhook/27ad14eb-8f60-46e5-b827-f99265904455/api/leads'
  );
  if (!res.ok) throw new Error('Failed to fetch leads');
  return res.json();
}

export async function fetchReferrals() {
  const res = await fetch(
    'https://n8nbotibonga.botibonga.com/webhook/27ad14eb-8f60-46e5-b827-f99265904455/api/referrals'
  );
  if (!res.ok) throw new Error('Failed to fetch referrals');
  return res.json();
}

export async function fetchAnalytics() {
  const res = await fetch(
    'https://n8nbotibonga.botibonga.com/webhook/27ad14eb-8f60-46e5-b827-f99265904455/api/analytics'
  );
  if (!res.ok) throw new Error('Failed to fetch analytics');
  const raw = await res.json();

  // Transform to UI-friendly format
  return {
    completedChecksOverTime: (raw.completed_over_time || []).map((d) => ({
      date: new Date(d.date).toLocaleDateString([], { month: 'short', day: 'numeric' }),
      count: Number(d.count) || 0,
    })),
    leadsByCategory: (raw.leads_by_category || []).map((d) => ({
      category: d.lead_category || 'Uncategorized',
      count: Number(d.count) || 0,
    })),
    milestoneDistribution: (raw.milestone_over_time || [])
      .filter((d) => d.milestone_stage != null)
      .map((d) => ({
        milestone: `Milestone ${d.milestone_stage}`,
        count: Number(d.count) || 0,
      })),
  };
}

export async function changePassword(username, newPassword) {
  const res = await fetch(
    'https://n8nbotibonga.botibonga.com/webhook/27ad14eb-8f60-46e5-b827-f99265904455/admin/change_password',
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, new_password: newPassword }),
    }
  );
  if (!res.ok) throw new Error('Failed to change password');
  return { success: true, message: 'Password changed successfully' };
}

export async function changeUsername(currentUsername, newUsername) {
  const res = await fetch(
    'https://n8nbotibonga.botibonga.com/webhook/27ad14eb-8f60-46e5-b827-f99265904455/admin/change_username',
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ current_username: currentUsername, new_username: newUsername }),
    }
  );
  if (!res.ok) throw new Error('Failed to change username');
  return { success: true, message: 'Username changed successfully' };
}

// Promotional Banner APIs
const BANNER_IMAGE_URL = 'https://ybkjpbolqufkaoymibgf.supabase.co/storage/v1/object/public/promotional-banners/current-banner.png';

export async function fetchPromotionalBanner() {
  try {
    const res = await fetch(
      'https://n8nbotibonga.botibonga.com/webhook/27ad14eb-8f60-46e5-b827-f99265904455/admin/get_promotional_banner'
    );
    if (!res.ok) throw new Error('Failed to fetch promotional banner');
    const data = await res.json();
    const banner = Array.isArray(data) ? data[0] : data;

    return {
      imageUrl: banner?.banner_url ? `${banner.banner_url}?t=${Date.now()}` : null,
      caption: banner?.caption || '',
      active: banner?.active === 'true' || banner?.active === true,
    };
  } catch {
    return { imageUrl: null, caption: '', active: false };
  }
}

export async function updatePromotionalBanner(imageFile, caption, active) {
  const formData = new FormData();
  formData.append('banner_image', imageFile);
  formData.append('caption', caption);
  formData.append('active', active ? 'True' : 'False');

  const res = await fetch(
    'https://n8nbotibonga.botibonga.com/webhook/27ad14eb-8f60-46e5-b827-f99265904455/update_promotional_banner',
    {
      method: 'PUT',
      body: formData,
    }
  );
  if (!res.ok) throw new Error('Failed to update promotional banner');
  return { success: true, message: 'Banner updated successfully' };
}

export async function toggleBannerStatus(active) {
  const res = await fetch(
    'https://n8nbotibonga.botibonga.com/webhook/27ad14eb-8f60-46e5-b827-f99265904455/admin/change_promotional_banner_status',
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ active: active ? 'true' : 'false' }),
    }
  );
  if (!res.ok) throw new Error('Failed to toggle banner status');
  return { success: true, message: 'Banner status updated successfully' };
}
